module.exports = __webpack_public_path__ + "static/media/bottom-arrow.cf4f4f01.svg";